import React, { HTMLAttributeAnchorTarget, useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { setSearchContext } from '../redux/search/search-slice';
import { setCurrentPage } from "../redux/settings/page-settings-slice";


export default function Search() {
    const dispatch = useAppDispatch();
    const searchByState = useAppSelector((state) => state.searchOptions.searchBy);
    const termState = useAppSelector((state) => state.searchOptions.term);
    const isInMaintenanceMode = useAppSelector((state) => state.pageSettings.isInMaintenanceMode);
    const [filter, setFilter] = useState(searchByState || '');
    const [query, setQuery] = useState(termState || '');

    const initSearch = (e) => {
        e.preventDefault();
        dispatch(setCurrentPage(1));
        dispatch(setSearchContext({ term: query, filter: filter }))
    }


    return (

        <form id="archive-form" className="performance-search-form" onSubmit={initSearch}>
            <label htmlFor="archive-dropdown" className="visually-hidden">Filter Your Search</label>
            <select
                id="archive-dropdown"
                className="performance-search-field performance-search-field-filter performance-search-dropdown"
                defaultValue={useAppSelector((state) => state.searchOptions.searchBy)}
                onChange={(e) => setFilter(e.target.value)}
                disabled={isInMaintenanceMode}>
                <option value="All">Opera</option>
                <option value="Composer">By Composer</option>
                <option value="CharacterOrRole">By Character or Role</option>
                <option value="Artist">By Artist Name</option>
            </select>
            <div className="performance-search-input-container">
                <label htmlFor="archive-input" className="visually-hidden"> Enter Search Term </label>
                <input
                    id="archive-input"
                    className="performance-search-field"
                    type="text"
                    disabled={isInMaintenanceMode}
                    placeholder={!isInMaintenanceMode && "Enter Search"}
                    defaultValue={useAppSelector((state) => state.searchOptions.term)}
                    onChange={(e) => setQuery(e.target.value)} />
                <button type="button" onClick={initSearch} className="performance-search-submit" disabled={isInMaintenanceMode}>
                    <span className="visually-hidden">Submit</span>
                </button>
            </div>
        </form>

    );
}